import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export const getMaintenanceStatus = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/v1/maintenance/`, {
      headers: {
        'Authorization': process.env.REACT_APP_API_TOKEN || ''
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching maintenance status:', error);
    // В случае ошибки возвращаем режим обслуживания выключенным
    return {
      is_maintenance_mode: false,
      title: maintenanceConfig.title,
      message: maintenanceConfig.message,
      estimatedTime: maintenanceConfig.estimatedTime,
    };
  }
};

// Дефолтные значения на случай проблем с API
export const maintenanceConfig = {
  title: "Сервис временно недоступен",
  message: "Привязка пластиковых карт к табельному номеру временно недоступна.",
  estimatedTime: "Сервис возобновит работу в ближайшее время",
};